export default __webpack_public_path__ + "static/media/stausIconCancel.13377d30.svg";